module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/prize_icon-803ae1985fadde284b3263f3500853f7.svg&quot;;"